import i18n from 'i18next';

import { IChat } from '../../../global';

export default (chat: IChat) => {
  const participantsCount = chat.participants?.length || 0;
  return i18n.t('chatParticipants', { count: participantsCount });
};
